

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDBLOGSECTIONWITHAPPROVAL
// ADDBLOGSECTIONWITHAPPROVAL


const ADDBLOGSECTIONWITHAPPROVAL= createAsyncThunk(
  "addBlogSectionWithApproval/addBlogSectionWithApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addBlogSectionWithApprovalSlice = createSlice({
  name: "addBlogSectionWithApprovalSlice",
  initialState: {
    addBlogSectionWithApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddBlogSectionWithApproval: (state) => {
        state.addBlogSectionWithApproval.loading = false
        state.addBlogSectionWithApproval.error = false
        state.addBlogSectionWithApproval.data = []
        state.addBlogSectionWithApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDBLOGSECTIONWITHAPPROVAL.fulfilled, (state, action) => {
      state.addBlogSectionWithApproval = {
        ...state.addBlogSectionWithApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDBLOGSECTIONWITHAPPROVAL.pending, (state, action) => {
      state.addBlogSectionWithApproval = {
        ...state.addBlogSectionWithApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDBLOGSECTIONWITHAPPROVAL.rejected, (state, action) => {
      state.addBlogSectionWithApproval = {
        ...state.addBlogSectionWithApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addBlogSectionWithApprovalAction = {
    ADDBLOGSECTIONWITHAPPROVAL,
};

export { addBlogSectionWithApprovalAction };
export default addBlogSectionWithApprovalSlice.reducer;
export const {setInitialStateOfaddBlogSectionWithApproval} = addBlogSectionWithApprovalSlice.actions
